import {startTypeShuffle, toggleModalSketch, utils} from "../components/utils";
import {gsapContext} from "../components/theme-scripts";

export function templateRedeemNftInit() {

	gsapContext.add(() => {

console.log('ok');

	});

}